import { useCallback, useEffect, useState } from "react";
import { api, errMsg } from "../lib/api";
import { toast } from "sonner";

/** Loads a Project workspace's full context (project, tasks, roles, teammates, programs, risk) in one call. */
export function useProjectWorkspace(id) {
  const [project, setProject] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [roles, setRoles] = useState([]);
  const [teammates, setTeammates] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [stakeholders, setStakeholders] = useState([]);
  const [risk, setRisk] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [proj, taskList, rolesList, teamList, progs, riskResp, stks] = await Promise.all([
        api.get("/projects"),
        api.get(`/projects/${id}/tasks`),
        api.get("/roles"),
        api.get("/teammates"),
        api.get("/programs"),
        api.get(`/projects/${id}/risk`).catch(() => ({ data: null })),
        api.get("/stakeholders").catch(() => ({ data: [] })),
      ]);
      setStakeholders(stks.data);
      setProject(proj.data.find((p) => p.id === id));
      setTasks(taskList.data);
      setRoles(rolesList.data);
      setTeammates(teamList.data);
      setPrograms(progs.data);
      setRisk(riskResp.data);
    } catch (e) { toast.error(errMsg(e)); }
    setLoading(false);
  }, [id]);

  useEffect(() => { load(); }, [load]);

  const refreshRisk = useCallback(async () => {
    try {
      const { data } = await api.get(`/projects/${id}/risk`);
      setRisk(data);
    } catch (e) { console.warn("refreshRisk failed", e); }
  }, [id]);

  return {
    project, setProject,
    tasks, setTasks,
    roles, teammates, programs, stakeholders,
    risk, setRisk, refreshRisk,
    loading, load,
  };
}
